// O que fica fixo sobre a tela do PDV (a engrenagem das Operações e o sinal do PDV sem internet)
// some enquanto o menu está aberto — senão fica flutuando por cima dos itens do menu.
const FIXOS_DO_PDV = '.botao-operacoes, .sinal-offline'

const escondeFixosDoPdv = (esconder) => {
    document.querySelectorAll(FIXOS_DO_PDV).forEach((elemento) => {
        elemento.classList.toggle('d-none', esconder)
    })
}

export const mostraMenu = () => {
    const rowOffcanvas = document.querySelector('.row-offcanvas')
    if(rowOffcanvas){
        rowOffcanvas.classList.add('relative')
        rowOffcanvas.classList.add('active')
    }
    const leftSide = document.querySelector('.left-side')
    if(leftSide){
        leftSide.classList.remove('collapse-left')
    }
    const rightSide = document.querySelector('.right-side')
    if(rightSide){
        rightSide.classList.remove('strech')
    }
    escondeFixosDoPdv(true)
}

export const escondeMenu = () =>{
    const rowOffcanvas = document.querySelector('.row-offcanvas')
    if(rowOffcanvas){
        rowOffcanvas.classList.remove('relative')
        rowOffcanvas.classList.remove('active')
    }
    const leftSide = document.querySelector('.left-side')
    if(leftSide){
        leftSide.classList.add('collapse-left')
    }
    const rightSide = document.querySelector('.right-side')
    if(rightSide){
        rightSide.classList.add('strech')
    }
    escondeFixosDoPdv(false)
}